module.exports = __webpack_public_path__ + "media/images/landing/icon-pricing-ca73f9bebafad7653695eb0466c75f25.svg";